<template>
    <div v-if="client">
        <!-- bonus rules route -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Bonus rules route</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.legal.bonusRulesRoute"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>

        <!-- organization info -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Organization info</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <content-string-ref
                            v-if="client.settings.viewSettings.legal.organizationInfo"
                            :content-ref="client.settings.viewSettings.legal.organizationInfo"
                            :delete-func="() => client.settings.viewSettings.legal.organizationInfo = null"
                        />
                        <content-string-selector
                            v-else
                            :clientId="clientId"
                            :add-func="(contentRef) => client.settings.viewSettings.legal.organizationInfo = contentRef"
                        />
                    </div>
                </div>
            </div>
        </div>
    
        <!-- main provisions -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Main provisions</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <content-string-ref v-if="client.settings.viewSettings.legal.mainProvisions"                            
                            :content-ref="client.settings.viewSettings.legal.mainProvisions"
                            :delete-func="() => client.settings.viewSettings.legal.mainProvisions = null" />
                        <content-string-selector v-else
                            :clientId="clientId"
                            :add-func="(contentRef) => client.settings.viewSettings.legal.mainProvisions = contentRef" />
                    </div>
                </div>
            </div>
        </div>

        <!-- main rules -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Main rules</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <ul>
                            <li
                                v-for="(rule, i) in client.settings.viewSettings.legal.mainRules"
                                :key="rule.contentId"
                            >
                                <content-string-ref
                                    :content-ref="rule"
                                    :delete-func="() => client.settings.viewSettings.legal.mainRules.splice(i, 1)"
                                />
                            </li>
                        </ul>
                        <content-string-selector
                            :clientId="clientId"
                            :add-func="(contentRef) => client.settings.viewSettings.legal.mainRules.push(contentRef)"
                        />
                    </div>
                </div>
            </div>
        </div>
        
        <!-- all rules -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">All rules</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <ul>
                            <li
                                v-for="(rule, i) in client.settings.viewSettings.legal.allRules"
                                :key="rule.contentId"
                            >
                                <content-string-ref
                                    :content-ref="rule"
                                    :delete-func="() => client.settings.viewSettings.legal.allRules.splice(i, 1)"
                                />
                            </li>
                        </ul>
                        <content-string-selector
                            :clientId="clientId"
                            :add-func="(contentRef) => client.settings.viewSettings.legal.allRules.push(contentRef)"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- Content Info -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Content Info</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <ul>
                            <li
                                v-for="(rule, i) in client.settings.viewSettings.legal.contentInfo"
                                :key="rule.contentId"
                            >
                                <content-string-ref
                                    :content-ref="rule"
                                    :delete-func="() => client.settings.viewSettings.legal.contentInfo.splice(i, 1)"
                                />
                            </li>
                        </ul>
                        <content-string-selector
                            :clientId="clientId"
                            :add-func="(contentRef) => client.settings.viewSettings.legal.contentInfo.push(contentRef)"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
             <div class="field-label is-normal">
                 <label class="label">Resticted countries</label>
             </div>
             <div class="field-body">
                <div class="field">
                    <p class="control">
                        <multiselect
                        :items="countries"
                        :selected="client.settings.viewSettings.legal.restrictedCountries"
                        :on-changed="(value) => this.client.settings.viewSettings.legal.restrictedCountries = value" />
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import clientService from '../../../../../services/client.service';
import countryService from '../../../../../services/country.service';

import ContentStringRef from '../../../../common/content/string/content-string-ref.vue';
import ContentStringSelector from '../../../../common/content/string/content-string-selector.vue';
import Multiselect from '../../../../common/multiselect.vue'

export default {
    name: 'client-settings-view-legal',
    components: { ContentStringRef, ContentStringSelector, Multiselect },
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        countries() {
            return countryService.getCountries();
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
            this.loadClient();
        },
        deleteContentRef(contentRefArray, index) {
            contentRefArray.splice(index, 1);
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/legal.vue